// import { useEffect, useState } from 'react';
// import { Box, Typography, Button, CircularProgress, Paper, Grid, IconButton, Stack, Checkbox, Collapse, Snackbar, Alert } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
// import { DataGrid } from '@mui/x-data-grid';
// import { useNavigate, Link } from 'react-router-dom';
// import axios from 'axios';
// import { FaUser } from 'react-icons/fa';
// import { VscNewFile } from 'react-icons/vsc';
// import { useMediaQuery, useTheme } from '@mui/material';
// import { useAuth } from '../../context/AuthContext';

// const normalizeDate = (v) => typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v.split("-").reverse().join("/") : v;

// export default function PurcInvoiceDetails({ connectionString, pdfString }) {

//     const { user, selectedCompany } = useAuth();
//     const API_URL = `${connectionString}/api`;
//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const role = user?.UserCategory || null;

//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//     const [invoiceRows, setInvoiceRows] = useState([]);
//     const [invoiceLoading, setInvoiceLoading] = useState(false);
//     const [invoiceSelectionModel, setInvoiceSelectionModel] = useState([]);

//     const [challanRows, setChallanRows] = useState([]);
//     const [challanLoading, setChallanLoading] = useState(true);
//     const [challanSelectionModel, setChallanSelectionModel] = useState([]);
//     const [selectedRows, setSelectedRows] = useState([]);             // array of full row objects for challans
//     const [selectedRowIds, setSelectedRowIds] = useState([]);         // array of string ids (ChallanId)

//     const [showPending, setShowPending] = useState(false);

//     // NEW: pdf loading state for a specific invoice row
//     const [pdfLoading, setPdfLoading] = useState(false);
//     const [pdfLoadingId, setPdfLoadingId] = useState(null);

//     const [pdfOverlayVisible, setPdfOverlayVisible] = useState(false);
//     const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//     const navigate = useNavigate();

//     // fetch challans
//     useEffect(() => {
//         if (!companyId || !userId) {
//             setChallanRows([]);
//             setChallanLoading(false);
//             return;
//         }

//         const controller = new AbortController();
//         let mounted = true;
//         setChallanLoading(true);

//         (async () => {
//             try {
//                 const res = await axios.get(`${API_URL}/Purchase-dispatch`, {
//                     params: { userId, userCategory: role, mode: 'ref', companyId },
//                     signal: controller.signal,
//                     headers: {
//                         'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
//                     }
//                 });
//                 if (!mounted) return;
//                 const data = Array.isArray(res.data) ? res.data : (Array.isArray(res.data.data) ? res.data.data : []);
//                 const rows = data.map((row, idx) => ({
//                     id: row.ChallanId != null ? String(row.ChallanId) : `c-${idx}`,
//                     ChallanId: row.ChallanId ?? null,
//                     ChallanAutoID: row.ChallanId ?? null,
//                     POId: row.ChallanId ?? null, // keep POId field name consistent with other code that expects it
//                     ChallanNumber: row.ChallanNumber ?? '-',
//                     RefNo: row.RefNo ?? '-',
//                     ChallanDate: row.ChallanDate ? new Date(row.ChallanDate).toLocaleDateString('en-GB') : '-',
//                     FirmName: row.FirmName ?? row.clientName ?? row.companyName ?? '-',
//                     ContactPerson: row.ContactPerson ?? row.clientContactPerson ?? '-',
//                     MobileNo: row.MobileNo ?? row.clientMobileNo ?? '-',
//                     City: row.City ?? '-',
//                     state: row.state ?? row.State ?? '-',
//                     BillAmt: typeof row.BillAmt === 'number' ? row.BillAmt : Number(row.BillAmt) || 0,
//                     PartyID: row.PartyID ?? row.partyId ?? row.PartyId ?? null,
//                     clientId: row.PartyID ?? row.partyId ?? row.PartyId ?? null,
//                 }));
//                 setChallanRows(rows);
//             } catch (err) {
//                 if (!axios.isCancel(err)) {
//                     console.error('🔴 Error fetching challans:', err);
//                     setSnackbar({ open: true, message: `Failed to fetch challans: ${err.message}`, severity: 'error' });
//                 }
//             } finally {
//                 if (mounted) setChallanLoading(false);
//             }
//         })();

//         return () => {
//             mounted = false;
//             controller.abort();
//         };
//     }, [userId, role, companyId]);

//     // fetch invoices
//     useEffect(() => {
//         if (!companyId || !userId) {
//             setInvoiceRows([]);
//             setInvoiceLoading(false);
//             return;
//         }

//         const controller = new AbortController();
//         let mounted = true;
//         setInvoiceLoading(true);

//         (async () => {
//             try {
//                 const response = await axios.get(`${API_URL}/get-PurcInvoice`, {
//                     params: { userId, userCategory: role, companyId },
//                     signal: controller.signal,
//                     headers: {
//                         'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
//                     }
//                 });
//                 if (!mounted) return;
//                 const data = Array.isArray(response.data) ? response.data : (Array.isArray(response.data.data) ? response.data.data : []);
//                 // console.log('Invoice API raw:', data);
//                 const rows = data.map((row, idx) => {
//                     // Normalize/alias server fields to the UI expected fields (FirmName, ContactPerson, MobileNo, City, GSTNo, PartyId)
//                     const partyId = row.PartyId ?? row.PartyID ?? row.partyId ?? null;
//                     return {
//                         id: row.purcInvoiceId != null ? String(row.purcInvoiceId) : `i-${idx}`,
//                         purcInvoiceId: row.purcInvoiceId ?? null,
//                         BillDate: row.BillDate ? new Date(row.BillDate).toLocaleDateString('en-GB') : '-',
//                         BillNumber: row.BillNumber ?? '-',
//                         RefNo: row.RefNo ?? '-',
//                         // UI expects FirmName, ContactPerson, MobileNo, City, state, GSTNo
//                         FirmName: row.FirmName ?? row.clientNameFromMaster ?? row.clientName ?? row.companyName ?? '-',
//                         ContactPerson: row.ContactPerson ?? row.clientContactPerson ?? row.clientContact ?? '-',
//                         MobileNo: row.MobileNo ?? row.clientMobileNo ?? row.clientMobile ?? '-',
//                         City: row.City ?? row.clientCity ?? '-',
//                         state: row.state ?? row.clientState ?? '-',
//                         GSTNo: row.GSTNo ?? row.GST ?? null,
//                         // numeric BillAmt for formatting function
//                         BillAmt: typeof row.BillAmt === 'number' ? row.BillAmt : Number(row.BillAmt) || 0,
//                         PartyId: partyId,
//                         PartyID: partyId,
//                         clientId: partyId,
//                     };
//                 });
//                 setInvoiceRows(rows);
//             } catch (err) {
//                 if (!axios.isCancel(err)) {
//                     console.error('🔴 Error fetching invoices:', err);
//                     setSnackbar({ open: true, message: `Failed to fetch invoices: ${err.message}`, severity: 'error' });
//                 }
//             } finally {
//                 if (mounted) setInvoiceLoading(false);
//             }
//         })();

//         return () => {
//             mounted = false;
//             controller.abort();
//         };
//     }, [userId, role, companyId]);

//     const handleTogglePending = () => setShowPending(prev => !prev);

//     const toggleInvoiceSelection = (rowId) => {
//         setInvoiceSelectionModel(prev => {
//             const idNum = Number(rowId);
//             return prev.includes(idNum) ? prev.filter(i => i !== idNum) : [...prev, idNum];
//         });
//     };

//     const toggleSelectAllInvoices = (checked) => {
//         setInvoiceSelectionModel(checked ? invoiceRows.map(r => Number(r.purcInvoiceId ?? r.id)) : []);
//     };

//     const handleView = (id) => {
//         if (!id) return;
//         window.open(`${window.location.origin}/Purchase-Invoice/${id}`, '_blank');
//     };

//     const handleInvoiceDelete = async (objAryId) => {
//         const numericIds = Array.isArray(objAryId) ? objAryId.map(Number).filter(n => !isNaN(n)) : [];
//         if (numericIds.length === 0 || !window.confirm(`Are you sure you want to delete ${numericIds.length} invoice(s)?`)) return;
//         console.log(numericIds);
//         try {
//             const payload = { objAryId: numericIds, companyId };
//             const { data } = await axios.post(`${API_URL}/Delete-PurcInvoices`, payload);
//             const deletedIds = Array.isArray(data.deletedIds) ? data.deletedIds.map(Number).filter(n => !isNaN(n)) : (data.deletedInvoices > 0 ? numericIds : []);
//             const referencedIds = Array.isArray(data.referencedIds) ? data.referencedIds.map(Number).filter(n => !isNaN(n)) : [];

//             if (deletedIds.length > 0) {
//                 setInvoiceRows(prev => prev.filter(row => !deletedIds.includes(Number(row.purcInvoiceId ?? row.id))));
//                 setInvoiceSelectionModel(prev => prev.filter(id => !deletedIds.includes(Number(id))));
//             }

//             setSnackbar({
//                 open: true,
//                 message: deletedIds.length > 0 && referencedIds.length === 0
//                     ? `Deleted ${deletedIds.length} invoice(s) successfully.`
//                     : deletedIds.length > 0 && referencedIds.length > 0
//                         ? `Deleted ${deletedIds.length} invoice(s). ${referencedIds.length} invoice(s) not deleted due to references.`
//                         : referencedIds.length > 0
//                             ? `No invoices deleted. ${referencedIds.length} invoice(s) have references.`
//                             : data.message || 'No invoices were deleted.',
//                 severity: deletedIds.length > 0 ? 'success' : 'info'
//             });
//         } catch (err) {
//             console.error('🔴 Error deleting invoices:', err);
//             setSnackbar({ open: true, message: `Failed to delete invoices: ${err.response?.data?.message || err.message}`, severity: 'error' });
//         }
//     };

//     // handle single row selection: only allow if clientId matches existing selectedRows (if any)
//     const handleRowSelection = (row, checked) => {
//         const rowClientId = String(row.clientId ?? row.PartyID ?? '');
//         const rowChallanIdStr = String(row.ChallanId ?? row.ChallanAutoID ?? row.id ?? '');

//         if (checked) {
//             // if some rows already selected, require same clientId
//             if (selectedRows.length > 0) {
//                 const firstClientId = String(selectedRows[0].clientId ?? selectedRows[0].PartyID ?? '');
//                 if (rowClientId !== firstClientId) {
//                     setSnackbar({ open: true, message: 'Cannot select challans with different Client IDs.', severity: 'warning' });
//                     return;
//                 }
//             }
//             // add
//             setSelectedRows(prev => prev.some(r => String(r.ChallanId ?? r.ChallanAutoID ?? r.id ?? '') === rowChallanIdStr) ? prev : [...prev, row]);
//             setSelectedRowIds(prev => prev.includes(rowChallanIdStr) ? prev : [...prev, rowChallanIdStr]);
//             setChallanSelectionModel(prev => prev.includes(Number(row.ChallanId)) ? prev : [...prev, Number(row.ChallanId)]);
//         } else {
//             // remove
//             setSelectedRows(prev => prev.filter(r => String(r.ChallanId ?? r.ChallanAutoID ?? r.id ?? '') !== rowChallanIdStr));
//             setSelectedRowIds(prev => prev.filter(id => id !== rowChallanIdStr));
//             setChallanSelectionModel(prev => prev.filter(id => id !== Number(row.ChallanId)));
//         }
//     };

//     // Called when "Go To Purchase Invoice" button is clicked
//     const HandleInvoice = () => {
//         if (selectedRows.length === 0) {
//             setSnackbar({ open: true, message: 'No challans selected.', severity: 'warning' });
//             return;
//         }
//         const firstOrder = selectedRows[0];
//         const selectedChallanAutoIDs = selectedRows.map(r => r.ChallanAutoID ?? r.ChallanId).filter(Boolean);
//         const clientId = firstOrder.clientId ?? firstOrder.PartyID ?? null;
//         if (!clientId) {
//             setSnackbar({ open: true, message: 'Selected challan does not have a clientId — cannot proceed.', severity: 'warning' });
//             return;
//         }
//         navigate(`/main/Purchase-InvoiceMaster-stepper-ref/${clientId}`, { state: { selectedChallanAutoIDs } });
//     };

//     const handleSnackbarClose = (e, reason) => {
//         if (reason === 'clickaway') return;
//         setSnackbar(prev => ({ ...prev, open: false }));
//     };

//     // ------------------ NEW: Open invoice PDF (web) ------------------
//     // This function follows your RN logic: fetch /companies, try to match BookName/FormName === "PurchaseInvoice"
//     // fallback to format_1. Downloads blob, opens in new tab (fallback to same tab if popup blocked).
//     const PDF_API_BASE = pdfString; // try to reuse connectionString base

//     const handleViewClick = async (invoiceId) => {
//         if (!invoiceId) return;

//         setPdfLoading(true);
//         setPdfLoadingId(invoiceId);

//         const userIdSafe = userId || 'usr1';
//         let formatId = 'format_1';
//         let bookNameToSend = 'PurchaseInvoice';
//         let bookIdToSend = null;

//         // === Keep your existing format detection logic (unchanged) ===
//         try {
//             const resp = await axios.get(`${API_URL}/companies`, { params: { companyId } });
//             let comps = [];
//             if (Array.isArray(resp?.data?.companies)) comps = resp.data.companies;
//             else if (Array.isArray(resp?.data)) comps = resp.data;
//             else if (resp?.data) comps = [resp.data];

//             let matched = null;
//             const eq = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();

//             for (const c of comps) {
//                 if (Array.isArray(c.formats)) {
//                     for (const f of c.formats) {
//                         const bn = String(f.BookName || f.bookName || "").trim();
//                         const fn = String(f.FormName || f.formName || "").trim();
//                         if (eq(bn, "PurchaseInvoice") || eq(fn, "PurchaseInvoice") || fn.toLowerCase().includes('purchaseinvoice')) {
//                             matched = { company: c, format: f };
//                             break;
//                         }
//                     }
//                     if (matched) break;
//                 }
//                 if (eq(c.BookName || c.bookName, "PurchaseInvoice")) {
//                     matched = { company: c, format: c };
//                     break;
//                 }
//             }

//             if (matched) {
//                 const f = matched.format;
//                 const foundBookId = f.BookID ?? f.BookId ?? f.bookId ?? null;
//                 if (foundBookId) {
//                     formatId = `format_${foundBookId}`;
//                     bookIdToSend = foundBookId;
//                 } else if (f.FormName || f.formName) {
//                     formatId = String(f.FormName || f.formName);
//                 }
//                 bookNameToSend = f.BookName ?? f.bookName ?? bookNameToSend;
//             }
//         } catch (err) {
//             console.warn("Format detection failed, using defaults");
//         }

//         let imageBase64 = null;
//         try {
//             const iconRes = await axios.get(`${API_URL}/company/GetIcon/${encodeURIComponent(companyId)}`);
//             if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
//                 const raw = iconRes.data.imageBase64;
//                 imageBase64 = typeof raw === 'string'
//                     ? raw.split('base64,').pop()?.replace(/\s/g, '') || null
//                     : null;
//             }
//         } catch (err) {
//             console.warn("Failed to fetch company icon:", err);
//         }

//         try {
//             // 1. Fetch full invoice data from main backend
//             const invoiceResp = await axios.get(`${API_URL}/get-purchase-invoice-data/${invoiceId}`, {
//                 params: { companyId },
//                 headers: { "Cache-Control": "no-store" }
//             });

//             const { master, details } = invoiceResp.data || {};
//             if (!master) throw new Error("No master data returned");

//             // 2. Build items array
//             const items = (details || []).map(d => {
//                 const qty = Number(d.Qty) || 0;
//                 const rate = Number(d.Rate) || 0;
//                 const disc = Number(d.Disc) || 0;
//                 const amount = qty * rate * (1 - disc / 100);

//                 return {
//                     hsnCode: d.HSNNo || "",
//                     description: d.productDescription || d.description || "",
//                     qty,
//                     rate,
//                     Unit: d.Unit || d.UnitName || "",
//                     discount: disc,
//                     cgst: Number(d.CGST || 0),
//                     sgst: Number(d.SGST || 0),
//                     igst: Number(d.IGST || 0),
//                     amount,
//                 };
//             });

//             // 3. Build complete pdfData payload
//             const pdfData = {
//                 companyId,
//                 companyName: master.FirmName || master.clientNameFromMaster || "",
//                 clientAddress: master.Address || "",
//                 address: master.Address || "",
//                 phone: master.MobileNo || "",
//                 gstNo: master.GSTNo || "",
//                 invoiceNo: master.BillNumber || "",
//                 referrenceNo: master.RefNo || "",
//                 date: master.BillDate ? normalizeDate(master.BillDate) : "",
//                 transport: master.transporterName || "SELF",
//                 challanNo: master.lrNumber || "",
//                 poNo: master.RefNo || "",
//                 shipToState: master.consigneeState || master.clientState || "",
//                 shipToStateCode: master.consigneeStateCode || "",
//                 LrNo: master.LRNo || master.LrNo || "",
//                 VehicleNo: master.VehicleNo || "",
//                 LrDate: master.LRDate ? normalizeDate(master.LRDate) : "",
//                 shipToGstNumber: master.consigneeGSTNo || master.shipToGstNumber || "",
//                 shipToConsigneename: master.ConName || "",
//                 items,
//                 toEmail: master.EmailId || "",
//                 totalAmount: master.grandTotal || 0,
//                 mobileNo: master.MobileNo || "",
//                 basicAmount: Number(master.BasicAmt) || 0,
//                 CGSTAmt: Number(master.CGSTAmt) || 0,
//                 SGSTAmt: Number(master.SGSTAmt) || 0,
//                 IGSTAmt: Number(master.IGSTAmt) || 0,
//                 RoundOff: Number(master.RoundOff) || 0,
//                 BillAmt: Number(master.BillAmt) || 0,
//                 clientState: master.clientState || "",
//                 clientStateCode: master.clientStateCode || "",
//                 imageBase64: imageBase64 || null,
//             };

//             const companyHeader = selectedCompany ? {
//                 CompanyName: selectedCompany.CompanyName || selectedCompany.companyName || "",
//                 Address: selectedCompany.Address || selectedCompany.address || "",
//                 MobileNo: selectedCompany.MobileNo || selectedCompany.mobileNo || "",
//                 GSTNo: selectedCompany.GSTNo || selectedCompany.gstNo || "",
//                 imageBase64: imageBase64 || null
//             } : null;

//             // 4. POST to PDF backend with full data + logo
//             const pdfResp = await axios.post(
//                 `${PDF_API_BASE}/api/pdf/PurchaseInvoice/${encodeURIComponent(invoiceId)}`,
//                 {
//                     docId: invoiceId,
//                     userId: userIdSafe,
//                     formatId,
//                     data: pdfData,
//                     company: companyHeader
//                 },
//                 { responseType: "blob" }
//             );

//             const blob = pdfResp.data;
//             if (!blob || blob.size === 0) throw new Error("Empty PDF");

//             const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

//             const newWin = window.open(blobUrl, "_blank");
//             if (newWin) {
//                 newWin.focus();
//                 const timer = setInterval(() => {
//                     if (newWin.closed) {
//                         URL.revokeObjectURL(blobUrl);
//                         clearInterval(timer);
//                     }
//                 }, 1000);
//             } else {
//                 setSnackbar({ open: true, message: "Popup blocked – showing PDF below", severity: "warning" });
//             }

//         } catch (err) {
//             console.error("Purchase Invoice PDF Error:", err);
//             setSnackbar({ open: true, message: "Failed to generate Purchase Invoice PDF", severity: "error" });
//         } finally {
//             setPdfLoading(false);
//             setPdfLoadingId(null);
//         }
//     };
//     // ------------------ END handleViewClick ------------------

//     const invoiceColumns = [
//         { field: 'BillDate', headerName: 'Bill Date', flex: 0.6 },
//         {
//             field: 'BillNumber', headerName: 'Bill No', flex: 0.6, align: 'center', headerAlign: 'center',
//             renderCell: (params) => (
//                 <Typography variant="body2" sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
//                     onClick={() => navigate(`/main/Purchase-InvoiceMaster-edit/${params.row.purcInvoiceId}`, { state: { clientId: params.row.PartyId ?? params.row.PartyID, invoiceId: params.row.purcInvoiceId } })}
//                 >
//                     {params.value ?? '-'}
//                 </Typography>
//             )
//         },
//         { field: 'RefNo', headerName: 'Ref No.', flex: 0.6 },
//         {
//             field: 'FirmName', headerName: 'Company Details', flex: 1.5,
//             renderCell: (params) => (
//                 <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
//                     <Typography variant="subtitle2" sx={{ fontSize: '0.85rem' }}>{params.row.FirmName || '-'}</Typography>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                         <FaUser color="#FF9800" />
//                         <Typography variant="body2">{params.row.ContactPerson || '-'}</Typography>
//                     </Stack>
//                     <Typography variant="body2" color="text.secondary">📲 {params.row.MobileNo || '-'}</Typography>
//                     <Typography variant="body2" color="text.secondary">{params.row.GSTNo ?? ''}</Typography>
//                 </Box>
//             )
//         },
//         {
//             field: 'City', headerName: 'Location', flex: 0.5, align: 'right', headerAlign: 'right',
//             renderCell: (params) => (
//                 <Box>
//                     <Typography variant="body2" fontWeight={600}>{params.row.City || 'N/A'}</Typography>
//                     <Typography variant="body2" color="text.secondary">{params.row.state || '-'}</Typography>
//                 </Box>
//             )
//         },
//         {
//             field: 'BillAmt', headerName: 'Total Amt', flex: 0.5, align: 'right', headerAlign: 'right',
//             valueFormatter: (params) => {
//                 const num = params.value;
//                 return typeof num === 'number' && !isNaN(num) ? `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-';
//             }
//         },
//         {
//             field: 'actions', headerName: 'Action', flex: 0.3, sortable: false, align: 'right', headerAlign: 'right',
//             renderCell: (params) => {
//                 // Show spinner for the invoice currently being loaded
//                 const thisId = params.row.purcInvoiceId ?? params.row.id;
//                 const isThisLoading = pdfLoading && String(pdfLoadingId) === String(thisId);
//                 return (
//                     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
//                         {isThisLoading ? (
//                             <CircularProgress size={20} />
//                         ) : (
//                             <IconButton
//                                 color="primary"
//                                 onClick={(e) => {
//                                     e.stopPropagation(); // do not select row
//                                     handleViewClick(thisId);
//                                 }}
//                                 size="small"
//                                 aria-label="view-pdf"
//                             >
//                                 <PrintIcon />
//                             </IconButton>
//                         )}
//                     </Box>
//                 );
//             }
//         },
//     ];


//     if (role !== "User") {
//         // add select column at the start
//         invoiceColumns.unshift({
//             field: 'select',
//             headerName: '',
//             width: 48,
//             sortable: false,
//             disableColumnMenu: true,
//             renderHeader: () => {
//                 const allIds = invoiceRows.map(r => Number(r.purcInvoiceId ?? r.id));
//                 const allSelected =
//                     allIds.length > 0 &&
//                     allIds.every(id => invoiceSelectionModel.includes(id));
//                 const someSelected =
//                     invoiceSelectionModel.length > 0 && !allSelected;

//                 return (
//                     <Checkbox
//                         checked={allSelected}
//                         indeterminate={someSelected}
//                         onChange={(e) => toggleSelectAllInvoices(e.target.checked)}
//                         size="small"
//                         disabled={invoiceRows.length === 0}
//                         inputProps={{
//                             'aria-label': allSelected
//                                 ? 'deselect all invoices'
//                                 : 'select all invoices',
//                         }}
//                     />
//                 );
//             },
//             renderCell: (params) => {
//                 const idNum = Number(params.row.purcInvoiceId ?? params.row.id);
//                 const checked = invoiceSelectionModel.includes(idNum);
//                 return (
//                     <Checkbox
//                         checked={checked}
//                         size="small"
//                         onChange={(e) => {
//                             e.stopPropagation();
//                             toggleInvoiceSelection(idNum);
//                         }}
//                     />
//                 );
//             },
//         });

//         // add delete column at the end
//         invoiceColumns.push({
//             field: 'delete',
//             headerName: 'Delete',
//             flex: 0.2,
//             align: 'right',
//             headerAlign: 'right',
//             sortable: false,
//             renderCell: (params) => {
//                 const idNum = Number(params.row.purcInvoiceId ?? params.row.id);
//                 const isSelected = invoiceSelectionModel.includes(idNum);
//                 return (
//                     <IconButton
//                         color="error"
//                         size="small"
//                         disabled={!isSelected}
//                         onClick={(e) => {
//                             e.stopPropagation();
//                             handleInvoiceDelete(invoiceSelectionModel);
//                         }}
//                         aria-label={isSelected ? 'delete' : 'select-to-enable-delete'}
//                     >
//                         <DeleteIcon />
//                     </IconButton>
//                 );
//             },
//         });
//     }

//     const challanColumns = [
//         {
//             field: 'select', headerName: '', width: 50, sortable: false, disableColumnMenu: true,
//             renderHeader: () => {
//                 const targetClientId = selectedRows[0]?.clientId ?? selectedRows[0]?.PartyID ?? (challanRows[0]?.clientId ?? challanRows[0]?.PartyID ?? null);
//                 const eligibleRows = targetClientId ? challanRows.filter(r => String(r.clientId ?? r.PartyID ?? '') === String(targetClientId)) : [];
//                 const allSelected = eligibleRows.length > 0 && eligibleRows.every(r => challanSelectionModel.includes(Number(r.ChallanId)));
//                 const someSelected = challanSelectionModel.length > 0 && !allSelected;
//                 return (
//                     <Checkbox checked={allSelected} indeterminate={someSelected}
//                         onChange={(e) => {
//                             const checked = e.target.checked;
//                             if (!checked) {
//                                 setChallanSelectionModel([]);
//                                 setSelectedRows([]);
//                                 setSelectedRowIds([]);
//                                 return;
//                             }
//                             const firstClientId = selectedRows[0]?.clientId ?? challanRows[0]?.clientId ?? challanRows[0]?.PartyID;
//                             if (!firstClientId) {
//                                 setSnackbar({ open: true, message: 'No client ID available to select.', severity: 'info' });
//                                 return;
//                             }
//                             const valid = challanRows.filter(r => String(r.clientId ?? r.PartyID ?? '') === String(firstClientId));
//                             setChallanSelectionModel(valid.map(r => Number(r.ChallanId)));
//                             setSelectedRows(valid);
//                             setSelectedRowIds(valid.map(r => String(r.ChallanId ?? r.ChallanAutoID ?? r.id)));
//                             if (valid.length < challanRows.length) {
//                                 setSnackbar({ open: true, message: 'Selected challans with matching Client ID only.', severity: 'info' });
//                             }
//                         }}
//                     />
//                 );
//             },
//             renderCell: ({ row }) => {
//                 const rowIdNum = Number(row.ChallanId);
//                 const checked = challanSelectionModel.includes(rowIdNum);
//                 return (
//                     <Checkbox checked={checked}
//                         onChange={(e) => {
//                             const checkedNow = e.target.checked;
//                             if (checkedNow && selectedRows.length > 0) {
//                                 const firstClientId = String(selectedRows[0].clientId ?? selectedRows[0].PartyID ?? '');
//                                 const rowClientId = String(row.clientId ?? row.PartyID ?? '');
//                                 if (firstClientId !== rowClientId) {
//                                     setSnackbar({ open: true, message: 'Cannot select challans with different Client IDs.', severity: 'warning' });
//                                     return;
//                                 }
//                             }
//                             setChallanSelectionModel(prev => checkedNow && !prev.includes(rowIdNum) ? [...prev, rowIdNum] : prev.filter(id => id !== rowIdNum));
//                             handleRowSelection(row, checkedNow);
//                         }}
//                     />
//                 );
//             }
//         },
//         { field: 'ChallanDate', headerName: 'Date', flex: 0.8, sortable: true },
//         {
//             field: 'ChallanNumber', headerName: 'Challan Number', flex: 1.2,
//             renderCell: (params) => (
//                 <Typography variant="body2" sx={{ textDecoration: 'underline' }}
//                     onClick={(e) => {
//                         e.stopPropagation();
//                     }}
//                 >
//                     {params.value ?? '-'}
//                 </Typography>
//             )
//         },
//         { field: 'RefNo', headerName: 'Ref No.', flex: 1 },
//         {
//             field: 'clientname', headerName: 'Client', flex: 2.5,
//             renderCell: (params) => (
//                 <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
//                     <Typography variant='subtitle2' sx={{ fontSize: '0.85rem' }}>{params.row.FirmName || '-'}</Typography>
//                     <Stack direction='row' alignItems='center' spacing={1}>
//                         <FaUser color='#FF9800' />
//                         <Typography variant='body2'>{params.row.ContactPerson || '-'}</Typography>
//                     </Stack>
//                     <Typography variant='body2' color='text.secondary'>📲 {params.row.MobileNo || '-'}</Typography>
//                 </Box>
//             )
//         },
//         {
//             field: 'location', headerName: 'Location', flex: 1.5, sortable: true,
//             renderCell: (params) => (
//                 <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                     <Typography variant="body2">{params.row.City || '-'}</Typography>
//                     <Typography variant="caption" color="text.secondary">{params.row.state || '-'}</Typography>
//                 </Box>
//             )
//         },
//         {
//             field: 'BillAmt', headerName: 'Bill Amount', flex: 1, type: 'number', align: 'right', headerAlign: 'right',
//             valueFormatter: (params) => {
//                 const num = params.value;
//                 return typeof num === 'number' && !isNaN(num) ? `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-';
//             }
//         },
//     ];

//     return (
//         <Box sx={{ mx: 'auto', maxWidth: '99%', pt: 2 }}>
//             <Grid container justifyContent='space-between' alignItems='center' mb={1}>
//                 <Box display='flex' alignItems='center' gap={1}>
//                     <IconButton component={Link} to='/main/Purchase-InvoiceMaster-stepper' size='small' sx={{ color: 'orange' }} aria-label='New Invoice'>
//                         <VscNewFile size={20} />
//                     </IconButton>
//                     <Typography variant='h6' fontWeight={600}>Purchase Invoice Details</Typography>
//                 </Box>
//                 <Box display='flex' alignItems='center' gap={1}>
//                     {selectedRows.length > 0 && (
//                         <Button variant='contained' color='primary' onClick={HandleInvoice} sx={{ borderRadius: 2, boxShadow: 4 }}>
//                             Go To Purchase Invoice
//                         </Button>
//                     )}
//                     <Button variant='contained' size='small' color='primary' onClick={handleTogglePending}>
//                         {showPending ? 'Hide Challans' : 'Show Challans'}
//                     </Button>
//                 </Box>
//             </Grid>

//             <Collapse in={showPending}>
//                 <Box mb={1}>
//                     <Paper sx={{ p: 2, borderRadius: 3 }}>
//                         <Typography variant='h6' fontWeight={600} mb={2}>Purchase Challan List</Typography>
//                         {challanLoading ? (
//                             <Box textAlign='center' py={4}><CircularProgress /></Box>
//                         ) : challanRows.length === 0 ? (
//                             <Typography textAlign='center' color='text.secondary'>No challans available</Typography>
//                         ) : (
//                             <DataGrid
//                                 rows={challanRows}
//                                 getRowHeight={() => 'auto'}
//                                 getRowId={(row) => row.ChallanId}
//                                 autoHeight
//                                 pageSizeOptions={[25, 50, 100]}
//                                 columns={challanColumns}
//                                 sx={{
//                                     '& .MuiDataGrid-columnHeaders': { backgroundColor: '#165bb5', color: '#FFFFFF', fontWeight: 'bold' },
//                                     '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
//                                     '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#ecf4fc' },
//                                 }}
//                             />
//                         )}
//                     </Paper>
//                 </Box>
//             </Collapse>

//             {invoiceLoading ? (
//                 <Box textAlign='center' py={3}><CircularProgress /></Box>
//             ) : (
//                 <Paper elevation={2} sx={{ borderRadius: 3, p: 2, overflow: 'hidden' }}>
//                     <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
//                         <Typography variant='h6' fontWeight={600}>Purchase Invoice List</Typography>
//                     </Box>
//                     {invoiceRows.length === 0 ? (
//                         <Typography textAlign='center' color='text.secondary'>No invoices available</Typography>
//                     ) : (
//                         <DataGrid
//                             rows={invoiceRows}
//                             getRowId={(row) => row.purcInvoiceId ?? row.id}
//                             getRowHeight={() => 'auto'}
//                             autoHeight
//                             pageSizeOptions={[5, 10]}
//                             disableRowSelectionOnClick
//                             columns={invoiceColumns}
//                             sx={{
//                                 '& .MuiDataGrid-columnHeaders': { backgroundColor: '#165bb5', color: '#FFFFFF', fontWeight: 'bold' },
//                                 '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
//                                 '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#ecf4fc' },
//                             }}
//                         />
//                     )}
//                 </Paper>
//             )}

//             <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
//                 <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//             {pdfOverlayVisible && (
//                 <Box sx={{
//                     position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
//                     backgroundColor: 'rgba(0,0,0,0.92)', zIndex: 9999,
//                     display: 'flex', justifyContent: 'center', alignItems: 'center',
//                     backdropFilter: 'blur(4px)'
//                 }}>
//                     <Box sx={{ textAlign: 'center', backgroundColor: '#111', padding: '40px 60px', borderRadius: '20px' }}>
//                         <CircularProgress size={60} thickness={4} sx={{ color: '#fff' }} />
//                         <Typography variant="h6" sx={{ color: '#fff', mt: 3, fontWeight: 600 }}>
//                             Generating Purchase Invoice PDF…
//                         </Typography>
//                         <Typography variant="body2" sx={{ color: '#aaa', mt: 1 }}>Please wait</Typography>
//                     </Box>
//                 </Box>
//             )}
//         </Box>
//     );
// }











import { useEffect, useState, useCallback } from 'react';
import { Box, Typography, Button, CircularProgress, Paper, Grid, IconButton, Stack, Checkbox, Collapse, Snackbar, Alert, TextField, InputAdornment, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Chip, Autocomplete, RadioGroup, Radio, FormControlLabel, Divider, LinearProgress } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { FaUser } from 'react-icons/fa';
import { VscNewFile } from 'react-icons/vsc';
import { useMediaQuery, useTheme } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useAuth } from '../../context/AuthContext';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import DescriptionIcon from '@mui/icons-material/Description';
import LinkIcon from '@mui/icons-material/Link';
import PersonIcon from '@mui/icons-material/Person';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PrintIcon from '@mui/icons-material/Print';
import { formatRows } from '../../utils/formatRows';
import NoDataComponent from '../../components/NoDataComponent';
import CustomNoDataOverlay from '../../components/CustomNoDataOverlay';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import * as XLSX from 'xlsx';
import SkeletonLoader from '../../components/SkeletonLoader';
import LoadingOverlay from '../../components/LoadingOverlay';
import { motion } from 'framer-motion';

const getFinancialYearRange = (now = new Date()) => {
    const month = now.getMonth();
    const startYear = month >= 3 ? now.getFullYear() : now.getFullYear() - 1;
    const from = `${startYear}-04-01`;
    const to = `${startYear + 1}-03-31`;
    return { from, to };
};

const normalizeDate = (v) => typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v.split("-").reverse().join("/") : v;

function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
}

function getInitials(name) {
    if (!name) return 'C';
    return name.trim().charAt(0).toUpperCase();
}

export default function CreditExpenseDetails({ connectionString, pdfString }) {

    const { user, selectedCompany } = useAuth();
    const API_URL = `${connectionString}/api`;
    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const role = user?.UserCategory || null;

    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [filterPopupOpen, setFilterPopupOpen] = useState(false);
    const [filterPopupMode, setFilterPopupMode] = useState('datewise');
    const [filterPopupFromDate, setFilterPopupFromDate] = useState('');
    const [filterPopupToDate, setFilterPopupToDate] = useState('');
    const [filterPopupFirms, setFilterPopupFirms] = useState([]);
    const [firmOptions, setFirmOptions] = useState([]);
    const [firmAllOptions, setFirmAllOptions] = useState([]);
    const [firmInputValue, setFirmInputValue] = useState('');
    const [firmLoading, setFirmLoading] = useState(false);
    const [filterPopupSnapshot, setFilterPopupSnapshot] = useState(null);
    const [filterPopupPurcAcs, setFilterPopupPurcAcs] = useState([]);
    const [purcAcOptions, setPurcAcOptions] = useState([]);
    const [purcAcAllOptions, setPurcAcAllOptions] = useState([]);
    const [purcAcInputValue, setPurcAcInputValue] = useState('');
    const [purcAcLoading, setPurcAcLoading] = useState(false);
    const [filterPopupExportCancelledOnly, setFilterPopupExportCancelledOnly] = useState(false);

    const [invoiceRows, setInvoiceRows] = useState([]);
    const [invoiceLoading, setInvoiceLoading] = useState(false);
    const [invoiceSelectionModel, setInvoiceSelectionModel] = useState([]);

    const [challanRows, setChallanRows] = useState([]);
    const [challanLoading, setChallanLoading] = useState(true);
    const [challanSelectionModel, setChallanSelectionModel] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);             // array of full row objects for challans
    const [selectedRowIds, setSelectedRowIds] = useState([]);         // array of string ids (ChallanId)

    const [showPending, setShowPending] = useState(false);

    // NEW: pdf loading state for a specific invoice row
    const [pdfLoading, setPdfLoading] = useState(false);
    const [pdfLoadingId, setPdfLoadingId] = useState(null);

    const [pdfOverlayVisible, setPdfOverlayVisible] = useState(false);
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
    const [openPurcInvoiceDeleteDialog, setOpenPurcInvoiceDeleteDialog] = useState(false);
    const [pendingPurcInvoiceDeleteIds, setPendingPurcInvoiceDeleteIds] = useState([]);
    const [deleting, setDeleting] = useState(false);
    const [exportExcelEnabled, setExportExcelEnabled] = useState(false);
    const [masterReportData, setMasterReportData] = useState([]);
    const [detailsReportData, setDetailsReportData] = useState([]);
    const [reportLoading, setReportLoading] = useState(false);


    // Search for small screen
    const [searchText, setSearchText] = useState('');

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(500));
    const navigate = useNavigate();

    // Credit Expense has no challan / PO reference, so there are no challans to fetch.

    // fetch invoices
    useEffect(() => {
        if (!companyId || !userId) {
            setInvoiceRows([]);
            setInvoiceLoading(false);
            return;
        }

        const controller = new AbortController();
        let mounted = true;
        setInvoiceLoading(true);

        (async () => {
            try {
                const response = await axios.get(`${API_URL}/get-CreditExpense`, {
                    params: { userId, userCategory: role, companyId },
                    signal: controller.signal,
                    headers: {
                        'Cache-Control': 'no-store'
                    }
                });
                if (!mounted) return;
                const data = Array.isArray(response.data) ? response.data : (Array.isArray(response.data.data) ? response.data.data : []);
                console.log(data);
                const rows = data.map((row, idx) => {
                    const partyId = row.PartyId ?? row.PartyID ?? row.partyId ?? null;
                    return {
                        id: row.purcInvoiceId != null ? String(row.purcInvoiceId) : `i-${idx}`,
                        purcInvoiceId: row.purcInvoiceId ?? null,
                        BillDate: row.BillDate ? new Date(row.BillDate).toLocaleDateString('en-GB') : '-',
                        BillNumber: row.BillNumber ?? '-',
                        InvoiceNumber: row.InvoiceNumber ?? '-',
                        InvoiceDate: row.InvoiceDate ? new Date(row.InvoiceDate).toLocaleDateString('en-GB') : '-',
                        RefNo: row.RefNo ?? '-',
                        FirmName: row.FirmName ?? row.clientNameFromMaster ?? row.clientName ?? row.companyName ?? '-',
                        ContactPerson: row.ContactPerson ?? row.clientContactPerson ?? row.clientContact ?? '-',
                        MobileNo: row.MobileNo ?? row.clientMobileNo ?? row.clientMobile ?? '-',
                        City: row.City ?? row.clientCity ?? '-',
                        state: row.state ?? row.clientState ?? '-',
                        GSTNo: row.GSTNo ?? row.GST ?? null,
                        BillAmt: typeof row.BillAmt === 'number' ? row.BillAmt : Number(row.BillAmt) || 0,
                        PartyId: partyId,
                        PartyID: partyId,
                        clientId: partyId,
                    };
                });
                setInvoiceRows(formatRows(rows));
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error('🔴 Error fetching invoices:', err);
                    setSnackbar({ open: true, message: `Failed to fetch invoices: ${err.message}`, severity: 'error' });
                }
            } finally {
                if (mounted) setInvoiceLoading(false);
            }
        })();

        return () => {
            mounted = false;
            controller.abort();
        };
    }, [userId, role, companyId]);

    const handleTogglePending = () => setShowPending(prev => !prev);

    const toggleInvoiceSelection = (rowId) => {
        setInvoiceSelectionModel(prev => {
            const idNum = Number(rowId);
            return prev.includes(idNum) ? prev.filter(i => i !== idNum) : [...prev, idNum];
        });
    };

    const toggleSelectAllInvoices = (checked) => {
        setInvoiceSelectionModel(checked ? invoiceRows.map(r => Number(r.purcInvoiceId ?? r.id)) : []);
    };

    const handleView = (id) => {
        if (!id) return;
        window.open(`${window.location.origin}/Purchase-Invoice/${id}`, '_blank');
    };

    const handleInvoiceDelete = (objAryId) => {
        const numericIds = Array.isArray(objAryId)
            ? objAryId.map(Number).filter(n => !isNaN(n))
            : [];

        if (!numericIds.length) return;

        setPendingPurcInvoiceDeleteIds(numericIds);
        setOpenPurcInvoiceDeleteDialog(true);
    };


    const confirmInvoiceDelete = async (objAryId) => {
        const numericIds = pendingPurcInvoiceDeleteIds;
        if (!numericIds.length || deleting) return;

        setDeleting(true);
        try {
            const payload = { objAryId: numericIds, companyId };
            const { data } = await axios.post(`${API_URL}/Delete-CreditExpenses`, payload);
            const deletedIds = Array.isArray(data.deletedIds) ? data.deletedIds.map(Number).filter(n => !isNaN(n)) : (data.deletedInvoices > 0 ? numericIds : []);
            const referencedIds = Array.isArray(data.referencedIds) ? data.referencedIds.map(Number).filter(n => !isNaN(n)) : [];

            if (deletedIds.length > 0) {
                setInvoiceRows(prev => prev.filter(row => !deletedIds.includes(Number(row.purcInvoiceId ?? row.id))));
                setInvoiceSelectionModel(prev => prev.filter(id => !deletedIds.includes(Number(id))));
            }

            if (deletedIds.length > 0 && referencedIds.length === 0) {
                setSnackbar({ open: true, message: `Deleted Successfully.`, severity: 'success' });
            } else if (deletedIds.length > 0 && referencedIds.length > 0) {
                setSnackbar({ open: true, message: "Cannot delete the selected item(s) because they are referenced in other records.", severity: "warning" });
            } else if (referencedIds.length > 0) {
                setSnackbar({ open: true, message: "Cannot delete the selected item(s) because they are referenced in other records.", severity: "warning" });
            } else {
                setSnackbar({ open: true, message: "Cannot delete the selected item(s) because they are referenced in other records.", severity: "warning" });
            }
        } catch (err) {
            console.error('🔴 Error deleting invoices:', err);
            setSnackbar({ open: true, message: `Failed to delete invoices: ${err.response?.data?.message || err.message}`, severity: 'error' });
        } finally {
            setDeleting(false);
            setOpenPurcInvoiceDeleteDialog(false);
            setPendingPurcInvoiceDeleteIds([]);
        }
    };

    const handleRowSelection = (row, checked) => {
        const rowClientId = String(row.clientId ?? row.PartyID ?? '');
        const rowChallanIdStr = String(row.ChallanId ?? row.ChallanAutoID ?? row.id ?? '');

        if (checked) {
            if (selectedRows.length > 0) {
                const firstClientId = String(selectedRows[0].clientId ?? selectedRows[0].PartyID ?? '');
                if (rowClientId !== firstClientId) {
                    setSnackbar({ open: true, message: 'Cannot select challans with different Client IDs.', severity: 'warning' });
                    return;
                }
            }
            setSelectedRows(prev => prev.some(r => String(r.ChallanId ?? r.ChallanAutoID ?? r.id ?? '') === rowChallanIdStr) ? prev : [...prev, row]);
            setSelectedRowIds(prev => prev.includes(rowChallanIdStr) ? prev : [...prev, rowChallanIdStr]);
            setChallanSelectionModel(prev => prev.includes(Number(row.ChallanId)) ? prev : [...prev, Number(row.ChallanId)]);
        } else {
            setSelectedRows(prev => prev.filter(r => String(r.ChallanId ?? r.ChallanAutoID ?? r.id ?? '') !== rowChallanIdStr));
            setSelectedRowIds(prev => prev.filter(id => id !== rowChallanIdStr));
            setChallanSelectionModel(prev => prev.filter(id => id !== Number(row.ChallanId)));
        }
    };

    const HandleInvoice = () => {
        if (selectedRows.length === 0) {
            setSnackbar({ open: true, message: 'No challans selected.', severity: 'warning' });
            return;
        }
        const firstOrder = selectedRows[0];
        const selectedChallanAutoIDs = selectedRows.map(r => r.ChallanAutoID ?? r.ChallanId).filter(Boolean);
        const clientId = firstOrder.clientId ?? firstOrder.PartyID ?? null;
        if (!clientId) {
            setSnackbar({ open: true, message: 'Selected challan does not have a clientId — cannot proceed.', severity: 'warning' });
            return;
        }
        navigate(`/main/Purchase-InvoiceMaster-stepper-ref/${clientId}`, { state: { selectedChallanAutoIDs } });
    };

    const handleSnackbarClose = (e, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    const PDF_API_BASE = pdfString;

    const handleViewClick = async (invoiceId) => {
        if (!invoiceId) return;

        setPdfLoading(true);
        setPdfLoadingId(invoiceId);
        setPdfOverlayVisible(true);

        const userIdSafe = userId || 'usr1';
        let formatId = 'format_1';
        let bookNameToSend = 'PurchaseInvoice';
        let bookIdToSend = null;

        let matchedFormat = null;
        try {
            // ✅ Add cache-buster to get fresh data
            const cacheBreaker = new Date().getTime();
            const resp = await axios.get(`${API_URL}/companies`, { params: { companyId, t: cacheBreaker } });
            let comps = [];
            if (Array.isArray(resp?.data?.companies)) comps = resp.data.companies;
            else if (Array.isArray(resp?.data)) comps = resp.data;
            else if (resp?.data) comps = [resp.data];

            let matched = null;
            const eq = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase();

            // Credit Expense uses the format saved for 'CreditExpense' in Printing Utilities;
            // if none is saved it falls back to the Purchase Invoice format.
            for (const wantedBook of ["CreditExpense", "PurchaseInvoice"]) {
                if (matched) break;
                for (const c of comps) {
                    if (Array.isArray(c.formats)) {
                        for (const f of c.formats) {
                            const bn = String(f.BookName || f.bookName || "").trim();
                            const fn = String(f.FormName || f.formName || "").trim();
                            if (eq(bn, wantedBook) || eq(fn, wantedBook) || fn.toLowerCase().includes(wantedBook.toLowerCase())) {
                                matched = { company: c, format: f };
                                break;
                            }
                        }
                        if (matched) break;
                    }
                    if (eq(c.BookName || c.bookName, wantedBook)) {
                        matched = { company: c, format: c };
                        break;
                    }
                }
            }

            if (matched) {
                const f = matched.format;
                const foundBookId = f.BookID ?? f.BookId ?? f.bookId ?? null;
                if (foundBookId) {
                    formatId = `format_${foundBookId}`;
                    bookIdToSend = foundBookId;
                } else if (f.FormName || f.formName) {
                    formatId = String(f.FormName || f.formName);
                }
                bookNameToSend = f.BookName ?? f.bookName ?? bookNameToSend;
                // ✅ Store matched format for Signature checking (fresh from API)
                matchedFormat = f;
            }
        } catch (err) {
            console.warn("Format detection failed, using defaults");
        }

        let imageBase64 = null;
        let signatureBase64 = null;
        try {
            const iconRes = await axios.get(`${API_URL}/company/GetIcon/${encodeURIComponent(companyId)}`);
            if (iconRes?.data?.success && iconRes?.data?.imageBase64) {
                const raw = iconRes.data.imageBase64;
                imageBase64 = typeof raw === 'string'
                    ? raw.split('base64,').pop()?.replace(/\s/g, '') || null
                    : null;
            }
            if (iconRes?.data?.signatureBase64) {
                signatureBase64 = iconRes.data.signatureBase64;
            }
        } catch (err) {
            console.warn("Failed to fetch company icon:", err);
        }
        // ✅ Use matched format's Signature (fresh from API, not cached context)
        if (!matchedFormat?.Signature) signatureBase64 = null;

        try {
            const invoiceResp = await axios.get(`${API_URL}/get-credit-expense-data/${invoiceId}`, {
                params: { companyId },
                headers: { "Cache-Control": "no-store" }
            });

            console.log(invoiceResp);

            const { master, details, company, termsAndConditions, additionalChargeItems } = invoiceResp.data || {};
            if (!master) throw new Error("No master data returned");
            const termsText = Array.isArray(termsAndConditions) && termsAndConditions.length > 0
                ? termsAndConditions
                    .sort((a, b) => a.SrNo - b.SrNo)
                    .map(t => `# ${t.TermsDescription}`)
                    .join('\n')
                : null;

            const items = (details || []).map(d => {
                const qty = Number(d.Qty) || 0;
                const rate = Number(d.Rate) || 0;
                const disc = Number(d.Disc) || 0;
                const amount = qty * rate * (1 - disc / 100);

                return {
                    hsnCode: d.HSNNo || "",
                    ItemCode: d.itemCode,
                    description: d.productDescription || d.description || "",
                    Remark: d.Remark || "",
                    qty,
                    rate,
                    Unit: d.Unit || d.UnitName || "",
                    discount: disc,
                    cgst: Number(d.CGST || 0),
                    sgst: Number(d.SGST || 0),
                    igst: Number(d.IGST || 0),
                    TaxableAmt: Number(d.TaxableAmt) || 0,
                    amount,
                };
            });

            // ✅ NEW: Additional Charges
            const additionalCharges = [1, 2, 3, 4, 5]
                .map(slot => {
                    const chargeItem = (additionalChargeItems || []).find(ci => Number(ci.TransType) === 199 + slot);
                    return {
                        name: chargeItem?.description || `Charge ${slot}`,
                        amount: Number(master[`Adc${slot}Amt`]) || 0,
                    };
                })
                .filter(c => c.amount > 0);

            const pdfData = {
                companyId,
                companyName: master.FirmName || "",
                clientAddress: master.clientAddress || "",
                address: master.Address || "",
                phone: master.MobileNo || "",
                gstNo: master.GSTNo || "",
                invoiceNo: master.InvoiceNumber || "",
                referrenceNo: master.RefNo || "",
                date: master.InvoiceDate ? normalizeDate(master.InvoiceDate) : "",
                transport: master.TransporterName || "SELF",
                challanNo: master.lrNumber || "",
                poNo: master.PONo || "",
                shipToState: master.consigneeState || "",
                shipToStateCode: master.consigneeStateCode || "",
                LrNo: master.LRNo || master.LrNo || "",
                VehicleNo: master.VehicleNo || "",
                LrDate: master.LRDate ? normalizeDate(master.LRDate) : "",
                shipToGstNumber: master.consigneeGSTNo || "",
                shipToConsigneename: master.ConName || "",
                items,
                toEmail: master.EmailId || "",
                totalAmount: master.grandTotal || 0,
                mobileNo: master.MobileNo || "",
                basicAmount: Number(master.TaxableAmt) || 0,
                additionalCharges,
                CGSTAmt: Number(master.CGSTAmt) || 0,
                SGSTAmt: Number(master.SGSTAmt) || 0,
                IGSTAmt: Number(master.IGSTAmt) || 0,
                RoundOff: Number(master.RoundOff) || 0,
                BillAmt: Number(master.BillAmt) || 0,
                clientState: master.clientState || "",
                clientStateCode: master.clientStateCode || "",
                imageBase64: imageBase64 || null,
                Remark: master.Remark || null,
                TCSAmt: master.TCSAmt || null,
                termsAndConditions: termsText,
                PaymentTerm: master.DueDays || null,
            };

            const companyHeader = company ? {
                CompId: companyId,
                CompanyName: company.CompanyName || company.companyName || "",
                Address: company.Address || company.address || "",
                MobileNo: company.MobileNo || company.mobileNo || "",
                EmailId: company.EmailId || "",
                Website: company.Website || "",
                GSTNo: company.GSTNo || company.gstNo || "",
                imageBase64: imageBase64 || null,
                signatureBase64: signatureBase64 || null,
                city: company.City || null,
                BkName1: company.BkName1 || null,
                BkBranch1: company.BkBranch1 || null,
                BkAcNo1: company.BkAcNo1 || null,
                BkIFSCCode1: company.BkIFSCCode1 || null,
                // ✅ NEW: Include Color from matchedFormat for PDF rendering
                headerColor: matchedFormat?.Color || '#000000',
            } : null;

            const pdfResp = await axios.post(
                `${PDF_API_BASE}/api/pdf/CreditExpense/${encodeURIComponent(invoiceId)}`,
                {
                    docId: invoiceId,
                    userId: userIdSafe,
                    formatId,
                    data: pdfData,
                    company: companyHeader
                },
                { responseType: "blob" }
            );

            const blob = pdfResp.data;
            if (!blob || blob.size === 0) throw new Error("Empty PDF");

            const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));

            // (old code : commented to implement pdf view in webview)
            // const newWin = window.open(blobUrl, "_blank");
            // if (newWin) {
            //     newWin.focus();
            //     const timer = setInterval(() => {
            //         if (newWin.closed) {
            //             URL.revokeObjectURL(blobUrl);
            //             clearInterval(timer);
            //         }
            //     }, 1000);
            // } else {
            //     setSnackbar({ open: true, message: "Popup blocked – showing PDF below", severity: "warning" });
            // }

            // (new code : Added to handle pdf in web and mobile both using webview)
            if (window.ReactNativeWebView) {

                const reader = new FileReader();

                reader.onloadend = () => {
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                            type: "OPEN_PDF",
                            base64: reader.result
                        })
                    );
                };

                reader.readAsDataURL(blob);

            } else {

                const newWin = window.open(blobUrl, "_blank");
                if (newWin) {
                    newWin.focus();
                    const timer = setInterval(() => {
                        if (newWin.closed) {
                            URL.revokeObjectURL(blobUrl);
                            clearInterval(timer);
                        }
                    }, 1000);
                } else {
                    setSnackbar({ open: true, message: "Popup blocked – showing PDF below", severity: "warning" });
                }
            }

        } catch (err) {
            console.error("Credit Expense PDF Error:", err);
            setSnackbar({ open: true, message: "Failed to generate Credit Expense PDF", severity: "error" });
        } finally {
            setPdfLoading(false);
            setPdfLoadingId(null);
            setPdfOverlayVisible(false);
        }
    };

    // Filter data for small screen
    const filteredInvoiceRows = invoiceRows.filter(row =>
        (row.BillNumber?.toLowerCase() || '').includes(searchText.toLowerCase()) ||
        (row.FirmName?.toLowerCase() || '').includes(searchText.toLowerCase())
    );

    const filteredChallanRows = challanRows.filter(row =>
        (row.ChallanNumber?.toLowerCase() || '').includes(searchText.toLowerCase()) ||
        (row.FirmName?.toLowerCase() || '').includes(searchText.toLowerCase())
    );

    const allVisibleInvoicesSelected = filteredInvoiceRows.length > 0 && filteredInvoiceRows.every(r => invoiceSelectionModel.includes(Number(r.purcInvoiceId ?? r.id)));

    const invoiceColumns = [
        { field: 'InvoiceDate', headerName: 'Bill Date', flex: 0.6, filterable: true, },
        {
            field: 'InvoiceNumber', headerName: 'Bill No', flex: 0.6, align: 'center', headerAlign: 'center',
            renderCell: (params) => (
                <Typography variant="body2" sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => navigate(`/main/CreditExpense-Master-edit/${params.row.purcInvoiceId}`, { state: { clientId: params.row.PartyId ?? params.row.PartyID, invoiceId: params.row.purcInvoiceId } })} > {params.value ?? '-'} </Typography>
            )
        },
        { field: 'RefNo', headerName: 'Ref No.', flex: 0.6 },
        {
            field: 'FirmName', headerName: 'FirmName', flex: 1.5,
            renderCell: (params) => (
                <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    <Typography variant="subtitle2" sx={{ fontSize: '0.85rem' }}>{params.row.FirmName || '-'}</Typography>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <FaUser color="#FF9800" />
                        <Typography variant="body2">{params.row.ContactPerson || '-'}</Typography>
                    </Stack>
                    <Typography variant="body2" color="text.secondary">📲 {params.row.MobileNo || '-'}</Typography>
                    <Typography variant="body2" color="text.secondary">{params.row.GSTNo ?? ''}</Typography>
                </Box>
            )
        },
        {
            field: 'City', headerName: 'Location', flex: 0.5, align: 'right', headerAlign: 'right', filterable: true,
            valueGetter: (value, row) => [row.City, row.state].filter(Boolean).join(', '),
            renderCell: (params) => (
                <Box>
                    <Typography variant="body2" fontWeight={600}>{params.row.City || 'N/A'}</Typography>
                    <Typography variant="body2" color="text.secondary">{params.row.state || '-'}</Typography>
                </Box>
            )
        },
        {
            field: 'BillAmt', headerName: 'Bill Amt', flex: 0.5, align: 'right', headerAlign: 'right',
            valueFormatter: (params) => {

                const num = Number(params); // convert string to number
                return !isNaN(num) ? `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-';
            }
        },
        {
            field: 'actions', headerName: 'Action', flex: 0.3, sortable: false, align: 'right', headerAlign: 'right', filterable: false,
            renderCell: (params) => {
                const thisId = params.row.purcInvoiceId ?? params.row.id;
                const isThisLoading = pdfLoading && String(pdfLoadingId) === String(thisId);
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
                        {isThisLoading ? (
                            <CircularProgress size={20} />
                        ) : (
                            <IconButton color="primary" onClick={(e) => { e.stopPropagation(); handleViewClick(thisId); }} size="small" aria-label="view-pdf" >
                                <PrintIcon />
                            </IconButton>
                        )}
                    </Box>
                );
            }
        },
    ];

    if (role !== "User") {
        invoiceColumns.unshift({
            field: 'select', headerName: '', width: 48, sortable: false, disableColumnMenu: true, filterable: false,
            renderHeader: () => {
                const allIds = invoiceRows.map(r => Number(r.purcInvoiceId ?? r.id));
                const allSelected = allIds.length > 0 && allIds.every(id => invoiceSelectionModel.includes(id));
                const someSelected = invoiceSelectionModel.length > 0 && !allSelected;

                return (
                    <Checkbox checked={allSelected} indeterminate={someSelected} onChange={(e) => toggleSelectAllInvoices(e.target.checked)} size="small" disabled={invoiceRows.length === 0} />
                );
            },
            renderCell: (params) => {
                const idNum = Number(params.row.purcInvoiceId ?? params.row.id);
                const checked = invoiceSelectionModel.includes(idNum);
                return (
                    <Checkbox checked={checked} size="small" onChange={(e) => { e.stopPropagation(); toggleInvoiceSelection(idNum); }} />
                );
            },
        });

        invoiceColumns.push({
            field: 'delete', headerName: 'Delete', flex: 0.2, align: 'right', headerAlign: 'right', sortable: false, filterable: false,
            renderCell: (params) => {
                const idNum = Number(params.row.purcInvoiceId ?? params.row.id);
                const isSelected = invoiceSelectionModel.includes(idNum);
                return (
                    <IconButton color="error" size="small" disabled={!isSelected} onClick={(e) => { e.stopPropagation(); handleInvoiceDelete(invoiceSelectionModel); }} aria-label={isSelected ? 'delete' : 'select-to-enable-delete'} >
                        <DeleteIcon />
                    </IconButton>
                );
            },
        });
    }

    const challanColumns = [
        {
            field: 'select', headerName: '', width: 50, sortable: false, disableColumnMenu: true, filterable: false,
            renderHeader: () => {
                const targetClientId = selectedRows[0]?.clientId ?? selectedRows[0]?.PartyID ?? (challanRows[0]?.clientId ?? challanRows[0]?.PartyID ?? null);
                const eligibleRows = targetClientId ? challanRows.filter(r => String(r.clientId ?? r.PartyID ?? '') === String(targetClientId)) : [];
                const allSelected = eligibleRows.length > 0 && eligibleRows.every(r => challanSelectionModel.includes(Number(r.ChallanId)));
                const someSelected = challanSelectionModel.length > 0 && !allSelected;
                return (
                    <Checkbox checked={allSelected} indeterminate={someSelected}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            if (!checked) {
                                setChallanSelectionModel([]);
                                setSelectedRows([]);
                                setSelectedRowIds([]);
                                return;
                            }
                            const firstClientId = selectedRows[0]?.clientId ?? challanRows[0]?.clientId ?? challanRows[0]?.PartyID;
                            if (!firstClientId) {
                                setSnackbar({ open: true, message: 'No client ID available to select.', severity: 'info' });
                                return;
                            }
                            const valid = challanRows.filter(r => String(r.clientId ?? r.PartyID ?? '') === String(firstClientId));
                            setChallanSelectionModel(valid.map(r => Number(r.ChallanId)));
                            setSelectedRows(valid);
                            setSelectedRowIds(valid.map(r => String(r.ChallanId ?? r.ChallanAutoID ?? r.id)));
                            if (valid.length < challanRows.length) {
                                setSnackbar({ open: true, message: 'Selected challans with matching Client ID only.', severity: 'info' });
                            }
                        }}
                    />
                );
            },
            renderCell: ({ row }) => {
                const rowIdNum = Number(row.ChallanId);
                const checked = challanSelectionModel.includes(rowIdNum);
                return (
                    <Checkbox checked={checked}
                        onChange={(e) => {
                            const checkedNow = e.target.checked;
                            if (checkedNow && selectedRows.length > 0) {
                                const firstClientId = String(selectedRows[0].clientId ?? selectedRows[0].PartyID ?? '');
                                const rowClientId = String(row.clientId ?? row.PartyID ?? '');
                                if (firstClientId !== rowClientId) {
                                    setSnackbar({ open: true, message: 'Cannot select challans with different Client IDs.', severity: 'warning' });
                                    return;
                                }
                            }
                            setChallanSelectionModel(prev => checkedNow && !prev.includes(rowIdNum) ? [...prev, rowIdNum] : prev.filter(id => id !== rowIdNum));
                            handleRowSelection(row, checkedNow);
                        }}
                    />
                );
            }
        },
        { field: 'ChallanDate', headerName: 'Date', flex: 0.8, sortable: true, filterable: true, },
        {
            field: 'ChallanNumber', headerName: 'Challan Number', flex: 1.2,
            renderCell: (params) => (
                <Typography variant="body2" sx={{ textDecoration: 'underline' }}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    {params.value ?? '-'}
                </Typography>
            )
        },
        { field: 'RefNo', headerName: 'Ref No.', flex: 1 },
        {
            field: 'clientname', headerName: 'FirmName', flex: 2.5,
            renderCell: (params) => (
                <Box sx={{ whiteSpace: 'normal', wordBreak: 'break-word', my: 1 }}>
                    <Typography variant='subtitle2' sx={{ fontSize: '0.85rem' }}>{params.row.FirmName || '-'}</Typography>
                    <Stack direction='row' alignItems='center' spacing={1}>
                        <FaUser color='#FF9800' />
                        <Typography variant='body2'>{params.row.ContactPerson || '-'}</Typography>
                    </Stack>
                    <Typography variant='body2' color='text.secondary'>📲 {params.row.MobileNo || '-'}</Typography>
                </Box>
            )
        },
        {
            field: 'location', headerName: 'Location', flex: 1.5, sortable: true, filterable: true,
            valueGetter: (value, row) => [row.City, row.state].filter(Boolean).join(', '),
            renderCell: (params) => (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="body2">{params.row.City || '-'}</Typography>
                    <Typography variant="caption" color="text.secondary">{params.row.state || '-'}</Typography>
                </Box>
            )
        },
        {
            field: 'BillAmt', headerName: 'Total Amt', flex: 1, type: 'number', align: 'right', headerAlign: 'right',
            valueFormatter: (params) => {
                const num = Number(params); // convert string to number
                return typeof num === 'number' && !isNaN(num) ? `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '-';
            }
        },
    ];

    // Mobile Card Renderers
    const renderMobileInvoiceCards = () => {
        if (invoiceLoading) return <SkeletonLoader count={3} height={120} />;
        if (filteredInvoiceRows.length === 0) return <Typography textAlign='center' py={4} color='text.secondary'><CustomNoDataOverlay /></Typography>;

        return filteredInvoiceRows.map(row => {
            const isSelected = invoiceSelectionModel.includes(Number(row.purcInvoiceId ?? row.id));
            const avatarColor = stringToColor(row.FirmName || 'Invoice');
            const initials = getInitials(row.FirmName);
            const location = [row.City, row.state].filter(Boolean).join(', ') || '—';
            const hasReference = Boolean(row.RefNo && row.RefNo !== '—');
            return (
                <Card
                    key={row.id}
                    onClick={() => navigate(`/main/CreditExpense-Master-edit/${row.purcInvoiceId}`, { state: { clientId: row.PartyId ?? row.PartyID, invoiceId: row.purcInvoiceId } })}
                    sx={{
                        mb: 2,
                        borderLeft: `6px solid ${hasReference ? '#FF9800' : '#1976d2'}`,
                        borderRadius: 2,
                        overflow: 'hidden',
                        boxShadow: 3,
                        bgcolor: 'background.paper',
                        cursor: 'pointer',
                        '&:hover': { boxShadow: 6 },
                    }}
                >
                    <CardContent sx={{ p: { xs: 1.5, sm: 2 }, py: 2 }}>
                        {/* Top Row */}
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
                                {role !== 'User' && (
                                    <Checkbox
                                        checked={isSelected}
                                        onChange={(e) => {
                                            e.stopPropagation();
                                            toggleInvoiceSelection(row.purcInvoiceId ?? row.id);
                                        }}
                                        onClick={e => e.stopPropagation()}
                                        size="small"
                                    />
                                )}
                                <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 36, height: 36, flexShrink: 0 }}>
                                    {initials}
                                </Avatar>
                                <Box sx={{ ml: 1.5, flex: 1, minWidth: 0 }}>
                                    <Typography variant="subtitle1" fontWeight={600} noWrap>
                                        {row.FirmName || '—'}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" noWrap>
                                        {location}
                                    </Typography>
                                </Box>
                            </Box>
                            <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0, ml: 1 }} noWrap>
                                {row.BillDate || '—'}
                            </Typography>
                        </Box>

                        {/* Bill No + Amount */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                                <DescriptionIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1, flexShrink: 0 }} />
                                <Typography variant="body2" color="text.secondary" noWrap>
                                    {row.InvoiceNumber || '—'}
                                </Typography>
                            </Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                ₹{Number(row.InvoiceDate || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Typography>
                        </Box>

                        {/* Ref No */}
                        <Box sx={{ mb: 0.8 }}>
                            {hasReference ? (
                                <Chip
                                    label={`Ref: ${row.RefNo}`}
                                    size="small"
                                    sx={{
                                        bgcolor: '#FFF3E0',
                                        color: '#E65100',
                                        fontWeight: 500
                                    }}
                                />
                            ) : (
                                <Chip
                                    label="Manual"
                                    size="small"
                                    sx={{ bgcolor: '#e7f5ff', color: "#0067bb" }}
                                />
                            )}
                        </Box>

                        <Divider sx={{ my: 1.5 }} />

                        {/* Bottom Row: Contact, Mobile, PDF */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: 0, flex: 1, flexWrap: "wrap" }}>
                                {row.ContactPerson && (
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <PersonIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1, flexShrink: 0 }} />
                                        <Typography variant="body2" color="text.secondary" noWrap>
                                            {row.ContactPerson}
                                        </Typography>
                                    </Box>
                                )}
                                {row.MobileNo && row.MobileNo !== '-' && (
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <PhoneAndroidIcon sx={{ fontSize: 18, color: '#10b981', mr: 1, flexShrink: 0 }} />
                                        <Typography variant="body2" color="#10b981" fontWeight={600} noWrap>
                                            {row.MobileNo}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                            <IconButton
                                color="primary"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(row.purcInvoiceId ?? row.id);
                                }}
                                size="small"
                                sx={{ flexShrink: 0 }}
                            >
                                <PrintIcon />
                            </IconButton>
                        </Box>
                    </CardContent>
                </Card>
            );
        });
    };

    const renderMobileChallanCards = () => {
        if (challanLoading) return <SkeletonLoader count={3} height={120} />;
        if (filteredChallanRows.length === 0) return <Typography textAlign='center' py={4} color='text.secondary'><CustomNoDataOverlay /></Typography>;

        return filteredChallanRows.map(row => {
            const isChecked = challanSelectionModel.includes(Number(row.ChallanId));
            const avatarColor = stringToColor(row.FirmName || 'Challan');
            const initials = getInitials(row.FirmName);
            const location = [row.City, row.state].filter(Boolean).join(', ') || '—';

            return (
                <Card
                    key={row.id}
                    sx={{
                        mb: 2,
                        borderLeft: '6px solid #ff9800',
                        borderRadius: 2,
                        overflow: 'hidden',
                        boxShadow: 3,
                        bgcolor: 'background.paper',
                    }}
                >
                    <CardContent sx={{ p: { xs: 1.5, sm: 2 }, py: 2 }}>
                        {/* Top Row */}
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
                                <Checkbox
                                    checked={isChecked}
                                    onChange={() => handleRowSelection(row, !isChecked)}
                                    size="small"
                                />
                                <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 36, height: 36, flexShrink: 0 }}>
                                    {initials}
                                </Avatar>
                                <Box sx={{ ml: 1.5, flex: 1, minWidth: 0 }}>
                                    <Typography variant="subtitle1" fontWeight={600} noWrap>
                                        {row.FirmName || '—'}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" noWrap>
                                        {location}
                                    </Typography>
                                </Box>
                            </Box>
                            <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0, ml: 1 }} noWrap>
                                {row.ChallanDate || '—'}
                            </Typography>
                        </Box>

                        {/* Challan No + Amount */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
                                <DescriptionIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1, flexShrink: 0 }} />
                                <Typography variant="body2" color="text.secondary" noWrap>
                                    {row.ChallanNumber || '—'}
                                </Typography>
                            </Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                ₹{Number(row.BillAmt || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </Typography>
                        </Box>

                        <Divider sx={{ my: 1.5 }} />

                        {/* Bottom: Contact + Mobile */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, minWidth: 0 }}>
                                {row.ContactPerson && (
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <PersonIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 1, flexShrink: 0 }} />
                                        <Typography variant="body2" color="text.secondary" noWrap>
                                            {row.ContactPerson}
                                        </Typography>
                                    </Box>
                                )}
                                {row.MobileNo && row.MobileNo !== '-' && (
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <PhoneAndroidIcon sx={{ fontSize: 18, color: '#10b981', mr: 1, flexShrink: 0 }} />
                                        <Typography variant="body2" color="#10b981" fontWeight={600} noWrap>
                                            {row.MobileNo}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            );
        });
    };

    const openFilterPopup = useCallback(() => {
        const { from, to } = getFinancialYearRange(new Date());
        const fromDate = filterPopupFromDate || from;
        const toDate = filterPopupToDate || to;
        if (!filterPopupFromDate) setFilterPopupFromDate(fromDate);
        if (!filterPopupToDate) setFilterPopupToDate(toDate);
        setFilterPopupSnapshot({ mode: filterPopupMode, fromDate, toDate, firms: filterPopupFirms, purcAcs: filterPopupPurcAcs, exportCancelledOnly: filterPopupExportCancelledOnly });
        setFilterPopupOpen(true);
    }, [filterPopupFromDate, filterPopupToDate, filterPopupMode, filterPopupFirms, filterPopupPurcAcs, filterPopupExportCancelledOnly]);

    const cancelFilterPopup = useCallback(() => {
        if (filterPopupSnapshot) {
            setFilterPopupMode(filterPopupSnapshot.mode);
            setFilterPopupFromDate(filterPopupSnapshot.fromDate);
            setFilterPopupToDate(filterPopupSnapshot.toDate);
            setFilterPopupFirms(filterPopupSnapshot.firms || []);
            setFilterPopupPurcAcs(filterPopupSnapshot.purcAcs || []);
            setFilterPopupExportCancelledOnly(filterPopupSnapshot.exportCancelledOnly || false);
        }
        setFilterPopupOpen(false);
    }, [filterPopupSnapshot]);

    const handleFilterOk = useCallback(async () => {
        setExportExcelEnabled(true);
        // setFilterPopupOpen(false);  // Keep popup open

        if (!companyId) {
            setSnackbar({
                open: true,
                message: 'Company not selected',
                severity: 'warning'
            });
            return;
        }

        if (!filterPopupFromDate || !filterPopupToDate) {
            setSnackbar({
                open: true,
                message: 'Please select date range',
                severity: 'warning'
            });
            return;
        }

        setReportLoading(true);

        try {
            // ── Prepare filter params ─────────────────────────────────
            const filterParams = {
                companyId,
                fromDate: filterPopupFromDate,
                toDate: filterPopupToDate,
                mode: filterPopupMode,
                // ✅ Send as comma-separated string or leave empty
                firms: filterPopupFirms.length > 0
                    ? filterPopupFirms.map(f => f.id).join(',')
                    : '',
                purchaseAcs: filterPopupPurcAcs.length > 0
                    ? filterPopupPurcAcs.map(s => s.id).join(',')
                    : '',
                exportCancelledOnly: filterPopupExportCancelledOnly,
                bookName: 'CREXP',
            };

            // ── Call single API ───────────────────────────────────────
            const response = await axios.get(
                `${API_URL}/purchase-invoice-register`,
                { params: filterParams }
            );

            const masterData = response?.data?.master?.data || [];
            const detailsData = response?.data?.details?.data || [];

            setMasterReportData(masterData);
            setDetailsReportData(detailsData);

            setSnackbar({
                open: true,
                message: `Report loaded: ${masterData.length} master records, ${detailsData.length} detail records`,
                severity: 'success'
            });

            console.log('Master Report Data:', masterData);
            console.log('Details Report Data:', detailsData);

        } catch (err) {
            console.error('Error fetching report data:', err);
            setSnackbar({
                open: true,
                message: err?.response?.data?.message || 'Failed to fetch report data',
                severity: 'error'
            });
        } finally {
            setReportLoading(false);
        }
    }, [
        companyId,
        filterPopupFromDate,
        filterPopupToDate,
        filterPopupMode,
        filterPopupFirms,
        filterPopupPurcAcs,
        filterPopupExportCancelledOnly,
        API_URL
    ]);

    const handleExportExcel = useCallback(() => {
        if (!masterReportData.length && !detailsReportData.length) {
            setSnackbar({ open: true, message: 'No data to export. Please apply filters first.', severity: 'warning' });
            return;
        }

        const formatDate = (val) => {
            if (!val) return '';
            const s = String(val).split('T')[0]; // strip time if present
            if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                const [y, m, d] = s.split('-');
                return `${d}-${m}-${y}`;
            }
            return val;
        };

        const buildSheet = (data, columns) => {
            const header = columns.map(c => c.header);
            const rows = data.map(row =>
                columns.map(c => {
                    const val = row[c.key] ?? '';
                    if (c.isDate) return formatDate(val);
                    if (val === 0 || val === '0' || val === 0.0) return '';
                    // Numeric columns often arrive from the API as strings (e.g. SQL
                    // DECIMAL fields serialized as text). aoa_to_sheet writes cells
                    // based on the JS value's type, so a string here becomes a text
                    // cell that Excel's status bar (Sum/Average) will not aggregate.
                    // Coerce to a real number so these columns total correctly.
                    if (c.isNumeric) {
                        const num = Number(val);
                        return Number.isNaN(num) ? val : num;
                    }
                    return val;
                })
            );
            return XLSX.utils.aoa_to_sheet([header, ...rows]);
        };

        // Master: Categoryid & BasicAmt removed; state→State; GSTRate placed before CGSTAmt
        const masterColumns = [
            { key: 'InvoiceDate', header: 'BillDate', isDate: true },
            { key: 'InvoiceNumber', header: 'BillNumber' },
            { key: 'FirmName', header: 'FirmName' },
            { key: 'GSTNo', header: 'GSTNo' },
            { key: 'state', header: 'State' },
            { key: 'StateCode', header: 'StateCode' },
            { key: 'TransactionType', header: 'TransactionType' },
            { key: 'GSTRate', header: 'GSTRate', isNumeric: true },
            { key: 'TaxableAmt', header: 'TaxableAmt', isNumeric: true },
            { key: 'CGSTAmt', header: 'CGSTAmt', isNumeric: true },
            { key: 'SGSTAmt', header: 'SGSTAmt', isNumeric: true },
            { key: 'IGSTAmt', header: 'IGSTAmt', isNumeric: true },
            { key: 'UTGSTAmt', header: 'UTGSTAmt', isNumeric: true },
            { key: 'GSTCEssAmt', header: 'GSTCessAmt', isNumeric: true },
            { key: 'BillAmt', header: 'BillAmt', isNumeric: true },
            { key: 'EwayBillNumber', header: 'EwayBillNumber' },
            { key: 'Remark', header: 'Remark' },
        ];

        // Details: exact sequence specified; state→State, itemCode→ItemCode, description→Description, QTY→Qty
        const detailsColumns = [
            { key: 'InvoiceDate', header: 'BillDate', isDate: true },
            { key: 'InvoiceNumber', header: 'BillNumber' },
            { key: 'FirmName', header: 'FirmName' },
            { key: 'GSTNo', header: 'GSTNo' },
            { key: 'state', header: 'State' },
            { key: 'StateCode', header: 'StateCode' },
            { key: 'TransactionType', header: 'TransactionType' },
            { key: 'itemCode', header: 'ItemCode' },
            { key: 'description', header: 'Description' },
            { key: 'HSNNo', header: 'HSNNo' },
            { key: 'Unit', header: 'Unit' },
            { key: 'QTY', header: 'Qty', isNumeric: true },
            { key: 'Rate', header: 'Rate', isNumeric: true },
            { key: 'Disc', header: 'Disc', isNumeric: true },
            { key: 'TaxableAmt', header: 'TaxableAmt', isNumeric: true },
            { key: 'GSTRate', header: 'GSTRate', isNumeric: true },
            { key: 'CGSTRate', header: 'CGSTRate', isNumeric: true },
            { key: 'SGSTRate', header: 'SGSTRate', isNumeric: true },
            { key: 'IGSTRate', header: 'IGSTRate', isNumeric: true },
            { key: 'CESSRate', header: 'CESSRate', isNumeric: true },
            { key: 'UTGSTRate', header: 'UTGSTRate', isNumeric: true },
            { key: 'CGSTAmt', header: 'CGSTAmt', isNumeric: true },
            { key: 'SGSTAmt', header: 'SGSTAmt', isNumeric: true },
            { key: 'IGSTAmt', header: 'IGSTAmt', isNumeric: true },
            { key: 'CESSAmt', header: 'CESSAmt', isNumeric: true },
            { key: 'UTGSTAmt', header: 'UTGSTAmt', isNumeric: true },
            { key: 'ItemRemark', header: 'ItemRemark' },
        ];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, buildSheet(masterReportData, masterColumns), 'Master');
        XLSX.utils.book_append_sheet(wb, buildSheet(detailsReportData, detailsColumns), 'Details');

        const fromDate = filterPopupFromDate || 'start';
        const toDate = filterPopupToDate || 'end';
        XLSX.writeFile(wb, `CreditExpenseRegister_${fromDate}_${toDate}.xlsx`);

        setSnackbar({ open: true, message: 'Excel exported successfully!', severity: 'success' });
    }, [masterReportData, detailsReportData, filterPopupFromDate, filterPopupToDate]);

    useEffect(() => {
        if (!filterPopupOpen) return;
        if (!API_URL || !companyId) return;
        let active = true;
        const fetchAllFirms = async () => {
            try {
                setFirmLoading(true);
                const res = await axios.get(`${API_URL}/company-search`, { params: { field: 'FirmName', search: '', companyId, limit: 1000 } });
                const data = Array.isArray(res?.data?.data) ? res.data.data : [];
                if (!active) return;
                const opts = data.map(r => ({ id: r?.id, label: r?.FirmName || '' })).filter(o => o.label);
                setFirmAllOptions(opts);
                if (!(firmInputValue || '').trim()) setFirmOptions(opts);
            } catch (err) {
                if (!active) return;
                setFirmAllOptions([]);
                setFirmOptions([]);
            } finally {
                if (active) setFirmLoading(false);
            }
        };
        fetchAllFirms();
        return () => { active = false; };
    }, [companyId, API_URL, filterPopupOpen]);

    useEffect(() => {
        if (!(firmInputValue || '').trim()) {
            setFirmOptions(firmAllOptions);
            return;
        }
        const q = firmInputValue.toLowerCase();
        setFirmOptions(firmAllOptions.filter(o => o.label.toLowerCase().includes(q)));
    }, [firmInputValue, firmAllOptions]);

    useEffect(() => {
        if (!filterPopupOpen) return;
        if (!API_URL || !companyId) return;
        let active = true;
        const fetchAllPurcAcs = async () => {
            try {
                setPurcAcLoading(true);
                const res = await axios.get(`${API_URL}/company-search`, { params: { field: 'FirmName', search: '', companyId, limit: 1000 } });
                const data = Array.isArray(res?.data?.data) ? res.data.data : [];
                if (!active) return;
                const opts = data.map(r => ({ id: r?.id, label: r?.FirmName || '' })).filter(o => o.label);
                setPurcAcAllOptions(opts);
                if (!(purcAcInputValue || '').trim()) setPurcAcOptions(opts);
            } catch (err) {
                if (!active) return;
                setPurcAcAllOptions([]);
                setPurcAcOptions([]);
            } finally {
                if (active) setPurcAcLoading(false);
            }
        };
        fetchAllPurcAcs();
        return () => { active = false; };
    }, [companyId, API_URL, filterPopupOpen]);

    useEffect(() => {
        if (!(purcAcInputValue || '').trim()) {
            setPurcAcOptions(purcAcAllOptions);
            return;
        }
        const q = purcAcInputValue.toLowerCase();
        setPurcAcOptions(purcAcAllOptions.filter(o => o.label.toLowerCase().includes(q)));
    }, [purcAcInputValue, purcAcAllOptions]);

    return (
        <Box sx={{ pt: 0.7, px: { xs: 2, sm: 3, md: 4 } }}>

            {/* ── Module Header ──────────────────────────────────────────────
                Credit Expense list header.
            ────────────────────────────────────────────────────────────────── */}
            <Box sx={{ mb: 2 }}>
                <Box sx={{ height: 4, background: 'linear-gradient(90deg, #1976d2 0%, #42a5f5 100%)', borderRadius: '6px 6px 0 0' }} />
                <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderTop: 0, borderRadius: '0 0 8px 8px', px: 2, py: 1.2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" fontWeight={700} color="primary.main" sx={{ fontSize: '1.05rem' }}>
                        Credit Expenses
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button variant="outlined" size="small" startIcon={<FilterAltIcon />} onClick={openFilterPopup} sx={{ textTransform: 'none' }}>Filter</Button>
                        <Button variant="contained" size="small" startIcon={<AddIcon />}
                            onClick={() => navigate("/main/CreditExpense-Master-stepper")}
                        >
                            {isSmallDevice ? 'Add' : 'Add Credit Expense'}
                        </Button>
                    </Box>
                </Paper>
            </Box>

            <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>
                <Box sx={{ p: { xs: 0.5, md: 0.5 } }}>
                    {/* Mobile Search & Bulk Actions */}
                    {isMobile && (
                        <>
                            <Box mb={2}>
                                <TextField fullWidth size="small" placeholder="Search..." value={searchText} onChange={(e) => setSearchText(e.target.value)} InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>, }} />
                            </Box>

                            {role !== 'User' && !showPending && invoiceSelectionModel.length > 0 && (
                                <Box mb={2} display="flex" alignItems="center" justifyContent="space-between" p={1} bgcolor="background.paper" borderRadius={2} boxShadow={1}>
                                    <Box display="flex" alignItems="center">
                                        <Checkbox checked={allVisibleInvoicesSelected} onChange={() => toggleSelectAllInvoices(!allVisibleInvoicesSelected)} />
                                        <Typography>{invoiceSelectionModel.length} selected</Typography>
                                    </Box>
                                    <IconButton color="error" onClick={() => handleInvoiceDelete(invoiceSelectionModel)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Box>
                            )}
                        </>
                    )}

                    {isMobile ? (
                        <Paper sx={{ borderRadius: 3, p: 1.5, overflow: 'hidden', display: !showPending ? 'block' : 'none' }}>
                            <Box display='flex' justifyContent='space-between' alignItems='center' mb={1.5}>
                                <Typography variant='h6' fontWeight={600}>Credit Expense List</Typography>
                            </Box>
                            {invoiceLoading && <SkeletonLoader count={3} height={120} />}
                            {!invoiceLoading && invoiceRows?.length === 0 && <NoDataComponent />}
                            {!invoiceLoading && invoiceRows?.length > 0 && renderMobileInvoiceCards()}
                        </Paper>
                    ) : (
                        <Paper elevation={2} sx={{ borderRadius: 3, p: 0.5, overflow: 'hidden' }}>
                            <Box sx={{ height: '71vh', width: '100%', position: 'relative' }}>
                                <LoadingOverlay isVisible={invoiceLoading} />
                                {!invoiceLoading && invoiceRows?.length === 0 && <NoDataComponent />}
                                {!invoiceLoading && invoiceRows?.length > 0 && <DataGrid rows={invoiceRows} getRowId={(row) => row.purcInvoiceId ?? row.id} getRowHeight={() => 'auto'} pageSizeOptions={[50, 100]} initialState={{ pagination: { paginationModel: { pageSize: 100 } } }} disableRowSelectionOnClick columns={invoiceColumns}
                                                sx={{
                                                    // Column header styling
                                                    '& .MuiDataGrid-columnHeaders': { backgroundColor: '#E0E0E0' },
                                                    '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 },
                                                    '& .MuiDataGrid-columnHeader': { backgroundColor: '#E0E0E0', color: '#000000', fontWeight: 'bold', },

                                                    // Background styling
                                                    '& .MuiDataGrid-filler': { backgroundColor: '#FFFFFF' },
                                                    '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#E0E0E0' },

                                                    // Row styling
                                                    '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF' },
                                                    '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#F9FAFB' },
                                                    '& .MuiDataGrid-row:hover': { backgroundColor: '#f1f5f9' },

                                                    // Selected row styling (with !important to override default MUI)
                                                    '& .MuiDataGrid-row.Mui-selected': { backgroundColor: '#BDBDBD !important' },

                                                    // Cell content alignment
                                                    '& .MuiDataGrid-cell': {
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    },

                                                    // Merge custom styles from parent
                                                    // ...sxProp,
                                                }}
                                                slots={{
                                                    noResultsOverlay: CustomNoDataOverlay
                                                }}
                                            />}
                            </Box>
                        </Paper>
                    )}
                </Box>
            </Paper>

            <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }} variant='filled'> {snackbar.message} </Alert>
            </Snackbar>
            {pdfOverlayVisible && (
                <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.92)', zIndex: 9999, display: 'flex', justifyContent: 'center', alignItems: 'center', backdropFilter: 'blur(4px)' }}>
                    <Box sx={{ textAlign: 'center', backgroundColor: '#111', padding: '40px 60px', borderRadius: '20px' }}>
                        <CircularProgress size={60} thickness={4} sx={{ color: '#fff' }} />
                        <Typography variant="h6" sx={{ color: '#fff', mt: 3, fontWeight: 600 }}> Generating Credit Expense PDF… </Typography>
                        <Typography variant="body2" sx={{ color: '#aaa', mt: 1 }}>Please wait</Typography>
                    </Box>
                </Box>
            )}

            {/* ── Delete Confirmation Dialog ──────────────────────────── */}
            <Dialog open={openPurcInvoiceDeleteDialog} onClose={() => { if (!deleting) setOpenPurcInvoiceDeleteDialog(false); }} maxWidth="xs" fullWidth>
                {deleting
                    ? <LinearProgress color="error" sx={{ height: 4 }} />
                    : <Box sx={{ height: 4, background: 'linear-gradient(90deg, #d32f2f 0%, #f44336 100%)' }} />}
                <Box sx={{ px: 2.5, pt: 2, pb: 1.5 }}>
                    <Typography variant="h6" fontWeight={700} sx={{ color: 'error.main', fontSize: '1.05rem' }}>Confirm Deletion</Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                        Are you sure you want to delete{' '}
                        <Typography component="span" variant="body2" fontWeight={700} color="error.main">{pendingPurcInvoiceDeleteIds.length}</Typography>
                        {' '}purchase invoice(s)? This action cannot be undone.
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ px: 2.5, py: 1.5, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button onClick={() => setOpenPurcInvoiceDeleteDialog(false)} variant="outlined" color="inherit" size="small" disabled={deleting}>Cancel</Button>
                    <Button color="error" variant="contained" size="small" disabled={deleting}
                        startIcon={deleting ? <CircularProgress size={14} color="inherit" /> : <DeleteIcon />}
                        onClick={confirmInvoiceDelete}>{deleting ? 'Deleting…' : 'Delete'}</Button>
                </Box>
            </Dialog>

            {/* Filter Dialog */}
            <Dialog
                open={filterPopupOpen}
                onClose={cancelFilterPopup}
                fullWidth
                maxWidth="sm"
                PaperProps={{ sx: { borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' } }}
            >
                {/* Header */}
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 1.5,
                        pt: 2,
                        px: 3,
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white'
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box
                            sx={{
                                bgcolor: 'rgba(255,255,255,0.2)',
                                borderRadius: '50%',
                                p: 0.8,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <FilterListIcon sx={{ color: 'white', fontSize: 20 }} />
                        </Box>
                        <Typography variant="h6" fontWeight={600} sx={{ fontSize: '1.1rem' }}>
                            Filter Options
                        </Typography>
                    </Box>
                    <IconButton
                        onClick={cancelFilterPopup}
                        size="small"
                        sx={{
                            color: 'white',
                            bgcolor: 'rgba(255,255,255,0.15)',
                            '&:hover': { bgcolor: 'rgba(255,255,255,0.25)' }
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ px: 3, py: 2, bgcolor: '#fafafa' }}>
                    {/* Filter Mode Selection */}
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            mb: 1,
                            mt: 1,
                            bgcolor: 'white',
                            border: '1px solid #e0e0e0',
                            borderRadius: 2,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            <Box sx={{ width: 4, height: 20, bgcolor: 'primary.main', borderRadius: 1 }} />
                            <Typography variant="subtitle1" fontWeight={600} sx={{ color: 'text.primary' }}>
                                Filter Mode
                            </Typography>
                        </Box>
                        <RadioGroup
                            row
                            value={filterPopupMode}
                            onChange={(e) => setFilterPopupMode(e.target.value)}
                            sx={{ display: 'flex', gap: 2 }}
                        >
                            <FormControlLabel
                                value="datewise"
                                control={
                                    <Radio
                                        size="small"
                                        sx={{
                                            '&.Mui-checked': { color: 'primary.main' }
                                        }}
                                    />
                                }
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Typography variant="body2" fontWeight={500}>
                                            📅 Datewise
                                        </Typography>
                                    </Box>
                                }
                                sx={{
                                    flex: 1,
                                    m: 0,
                                    bgcolor: filterPopupMode === 'datewise' ? '#e3f2fd' : '#f5f5f5',
                                    borderRadius: 1.5,
                                    px: 2,
                                    py: 0.5,
                                    border: filterPopupMode === 'datewise' ? '2px solid' : '2px solid transparent',
                                    borderColor: 'primary.main',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        bgcolor: filterPopupMode === 'datewise' ? '#e3f2fd' : '#eeeeee',
                                    }
                                }}
                            />
                            <FormControlLabel
                                value="partywise"
                                control={
                                    <Radio
                                        size="small"
                                        sx={{
                                            '&.Mui-checked': {
                                                color: 'primary.main',
                                            }
                                        }}
                                    />
                                }
                                label={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <Typography variant="body2" fontWeight={500}>
                                            👥 Partywise
                                        </Typography>
                                    </Box>
                                }
                                sx={{
                                    flex: 1,
                                    m: 0,
                                    bgcolor: filterPopupMode === 'partywise' ? '#e3f2fd' : '#f5f5f5',
                                    borderRadius: 1.5,
                                    px: 2,
                                    py: 0.5,
                                    border: filterPopupMode === 'partywise' ? '2px solid' : '2px solid transparent',
                                    borderColor: 'primary.main',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        bgcolor: filterPopupMode === 'partywise' ? '#e3f2fd' : '#eeeeee',
                                    }
                                }}
                            />
                        </RadioGroup>
                    </Paper>

                    {/* Filter Fields */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        {/* Date Range */}
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#ff6b6b', borderRadius: 1 }} />
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'text.primary' }}>
                                    📆 Date Range
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="caption"
                                        fontWeight={600}
                                        sx={{ mb: 0.5, display: 'block', color: 'text.secondary' }}
                                    >
                                        From Date
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        value={filterPopupFromDate}
                                        onChange={(e) => setFilterPopupFromDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: '#f8f9fa',
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: '#e9ecef' },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#dee2e6' }
                                        }}
                                    />
                                </Box>
                                <Box sx={{ flex: 1 }}>
                                    <Typography
                                        variant="caption"
                                        fontWeight={600}
                                        sx={{ mb: 0.5, display: 'block', color: 'text.secondary' }}
                                    >
                                        To Date
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="date"
                                        value={filterPopupToDate}
                                        onChange={(e) => setFilterPopupToDate(e.target.value)}
                                        InputLabelProps={{ shrink: true }}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: '#f8f9fa',
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: '#e9ecef' },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#dee2e6' }
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Paper>

                        {/* Firm Name */}
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#4ecdc4', borderRadius: 1 }} />
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'text.primary' }}>
                                    🏢 Firm Name
                                </Typography>
                            </Box>
                            <Autocomplete
                                multiple
                                options={firmOptions}
                                value={filterPopupFirms}
                                loading={firmLoading}
                                inputValue={firmInputValue}
                                onInputChange={(_, v) => setFirmInputValue(v)}
                                onChange={(_, v) => setFilterPopupFirms(v)}
                                getOptionLabel={o => o.label || ''}
                                isOptionEqualToValue={(o, v) => o.id === v.id}
                                renderTags={() => null}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            checked={selected}
                                            size="small"
                                            sx={{
                                                mr: 1,
                                                color: '#4ecdc4',
                                                '&.Mui-checked': { color: '#4ecdc4' }
                                            }}
                                        />
                                        <Typography variant="body2">{option?.label || ''}</Typography>
                                    </li>
                                )}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        fullWidth
                                        placeholder={filterPopupFirms?.length ? `${filterPopupFirms.length} firm(s) selected` : 'Select firms (ALL)'}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: '#f8f9fa',
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: '#e9ecef' },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#dee2e6' }
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    {filterPopupFirms?.length > 0 && (
                                                        <Chip
                                                            label={`${filterPopupFirms.length}`}
                                                            size="small"
                                                            sx={{
                                                                ml: 0.5,
                                                                height: 22,
                                                                bgcolor: '#4ecdc4',
                                                                color: 'white',
                                                                fontWeight: 700,
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    )}
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                            endAdornment: (
                                                <>
                                                    {firmLoading ? <CircularProgress size={16} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            )
                                        }}
                                    />
                                )}
                                PaperComponent={props => <Paper elevation={4} {...props} />}
                                ListboxProps={{ style: { maxHeight: 200 } }}
                            />
                        </Paper>

                        {/* Purchase Account */}
                        <Paper
                            elevation={0}
                            sx={{
                                p: 2,
                                bgcolor: 'white',
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                <Box sx={{ width: 4, height: 20, bgcolor: '#f7b731', borderRadius: 1 }} />
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'text.primary' }}>
                                    💰 Purchase Account
                                </Typography>
                            </Box>
                            <Autocomplete
                                multiple
                                options={purcAcOptions}
                                value={filterPopupPurcAcs}
                                loading={purcAcLoading}
                                inputValue={purcAcInputValue}
                                onInputChange={(_, v) => setPurcAcInputValue(v)}
                                onChange={(_, v) => setFilterPopupPurcAcs(v)}
                                getOptionLabel={o => o.label || ''}
                                isOptionEqualToValue={(o, v) => o.id === v.id}
                                renderTags={() => null}
                                renderOption={(props, option, { selected }) => (
                                    <li {...props}>
                                        <Checkbox
                                            checked={selected}
                                            size="small"
                                            sx={{
                                                mr: 1,
                                                color: '#f7b731',
                                                '&.Mui-checked': { color: '#f7b731' }
                                            }}
                                        />
                                        <Typography variant="body2">{option?.label || ''}</Typography>
                                    </li>
                                )}
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        fullWidth
                                        placeholder={filterPopupPurcAcs?.length ? `${filterPopupPurcAcs.length} account(s) selected` : 'Select accounts (ALL)'}
                                        sx={{
                                            '& .MuiInputBase-root': {
                                                bgcolor: '#f8f9fa',
                                                borderRadius: 1.5,
                                                '&:hover': { bgcolor: '#e9ecef' },
                                                '&.Mui-focused': { bgcolor: 'white' }
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#dee2e6' }
                                        }}
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    {filterPopupPurcAcs?.length > 0 && (
                                                        <Chip
                                                            label={`${filterPopupPurcAcs.length}`}
                                                            size="small"
                                                            sx={{
                                                                ml: 0.5,
                                                                height: 22,
                                                                bgcolor: '#f7b731',
                                                                color: 'white',
                                                                fontWeight: 700,
                                                                fontSize: '0.75rem'
                                                            }}
                                                        />
                                                    )}
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                            endAdornment: (
                                                <>
                                                    {purcAcLoading ? <CircularProgress size={16} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            )
                                        }}
                                    />
                                )}
                                PaperComponent={props => <Paper elevation={4} {...props} />}
                                sx={{}}
                            />
                        </Paper>

                        {/* Export Cancelled Bills Only */}
                        <Paper
                            elevation={0}
                            sx={{
                                px: 2,
                                py: 1,
                                bgcolor: 'white',
                                border: '1px solid #e0e0e0',
                                borderRadius: 2,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={filterPopupExportCancelledOnly}
                                        onChange={e => setFilterPopupExportCancelledOnly(e.target.checked)}
                                        size="small"
                                        sx={{
                                            color: '#ee5a6f',
                                            '&.Mui-checked': { color: '#ee5a6f' }
                                        }}
                                    />
                                }
                                label="Export Cancelled Bills Only"
                                sx={{ mb: 0 }}
                            />
                        </Paper>
                    </Box>
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        py: 1.5,
                        bgcolor: '#fafafa',
                        borderTop: '1px solid #e0e0e0',
                        gap: 2
                    }}
                >
                    <Button
                        onClick={cancelFilterPopup}
                        variant="outlined"
                        sx={{
                            flex: 1,
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            py: 1,
                            borderColor: '#d0d0d0',
                            color: 'text.secondary',
                            '&:hover': { borderColor: '#999', bgcolor: '#f5f5f5' }
                        }}
                    >
                        ✕ Cancel
                    </Button>

                    {/* Export Excel Button */}
                    <Button
                        onClick={handleExportExcel}
                        variant="outlined"
                        disabled={!exportExcelEnabled}
                        sx={{
                            flex: 1, borderRadius: 2, textTransform: 'none', fontWeight: 600, py: 1.2,
                            borderColor: !exportExcelEnabled ? '#d0d0d0' : '#2e7d32',
                            color: !exportExcelEnabled ? 'text.disabled' : '#2e7d32',
                            '&:hover': {
                                borderColor: '#2e7d32',
                                bgcolor: '#f1f8e9'
                            },
                            '&.Mui-disabled': {
                                borderColor: '#d0d0d0',
                                color: 'text.disabled'
                            }
                        }}
                    >
                        📊 Export Excel
                    </Button>

                    <Button
                        onClick={handleFilterOk}
                        variant="contained"
                        sx={{
                            flex: 1,
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                            py: 1,
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
                            '&:hover': {
                                background: 'linear-gradient(135deg, #5568d3 0%, #63408a 100%)',
                                boxShadow: '0 6px 16px rgba(102, 126, 234, 0.4)'
                            }
                        }}
                    >
                        ✓ Apply Filters
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>
    );
}